// extracted by mini-css-extract-plugin
module.exports = {"action":"Action_action__3Fdlp","active":"Action_active__vA-VW"};